import { render, staticRenderFns } from "./editPlatform.vue?vue&type=template&id=76d91eaa&"
import script from "./editPlatform.vue?vue&type=script&lang=js&"
export * from "./editPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports